/** Códigos INE de región (Chile), alineados con `REGIONES_COMUNA` en `regiones.ts`. */
const REGION_CODE_BY_NAME: Record<string, number> = {
  'arica y parinacota': 15,
  tarapaca: 1,
  antofagasta: 2,
  atacama: 3,
  coquimbo: 4,
  valparaiso: 5,
  'libertador gral. bernardo ohiggins': 6,
  maule: 7,
  biobio: 8,
  nuble: 16,
  'la araucania': 9,
  'los rios': 14,
  'los lagos': 10,
  'region aisen del gral. carlos ibanez del campo': 11,
  'aisen del gral. carlos ibanez del campo': 11,
  'region de magallanes y de la antartica chilena': 12,
  'magallanes y de la antartica chilena': 12,
  'metropolitana de santiago': 13,
  // Alias con prefijo "Región" (datos legacy / integraciones)
  'region del libertador gral. bernardo ohiggins': 6,
  'region del maule': 7,
  'region del biobio': 8,
  'region de la araucania': 9,
  'region de los rios': 14,
  'region de los lagos': 10,
  'region metropolitana de santiago': 13,
};

export function normalizeRegionName(value: string): string {
  return String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’']/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

export function getCementoRegionCode(regionName: string): number | null {
  return REGION_CODE_BY_NAME[normalizeRegionName(regionName)] ?? null;
}
